import React from 'react';
import styled from 'styled-components';
import { radiusPill } from '../../tokens/radii';

export type BadgeVariant = 'success' | 'warning' | 'danger' | 'info' | 'neutral' | 'brand';

const variantMap: Record<BadgeVariant, { bg: string; color: string }> = {
  success: { bg: '#E1F5EE', color: '#085041' },
  warning: { bg: '#FAEEDA', color: '#633806' },
  danger:  { bg: '#FCEBEB', color: '#791F1F' },
  info:    { bg: '#E6F1FB', color: '#0C447C' },
  neutral: { bg: '#F9F8F5', color: '#5C5C58' },
  brand:   { bg: '#f5edf6', color: '#6f2176' },
};

interface BadgeProps {
  variant?: BadgeVariant;
  children: React.ReactNode;
}

const StyledBadge = styled.span<{ $bg: string; $color: string }>`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 3px 9px;
  border-radius: ${radiusPill};
  font-size: 11px;
  font-weight: 600;
  background: ${({ $bg }) => $bg};
  color: ${({ $color }) => $color};
  border: ${({ $bg }) => $bg === '#F9F8F5' ? '0.5px solid #D3D1C7' : 'none'};
`;

export const Badge: React.FC<BadgeProps> = ({ variant = 'neutral', children }) => {
  const { bg, color } = variantMap[variant];
  return <StyledBadge $bg={bg} $color={color}>{children}</StyledBadge>;
};

// ── Tag — rótulo com cor totalmente personalizada (categorias, salas) ─────────

interface TagProps {
  color: string;
  background: string;
  children: React.ReactNode;
  onRemove?: () => void;
}

const StyledTag = styled.span<{ $bg: string; $color: string }>`
  display: inline-flex;
  align-items: center;
  gap: 3px;
  padding: ${({ onRemove }: any) => onRemove ? '4px 6px 4px 9px' : '3px 9px'};
  border-radius: ${radiusPill};
  font-size: 11px;
  font-weight: 600;
  background: ${({ $bg }) => $bg};
  color: ${({ $color }) => $color};
`;

const TagRm = styled.button<{ $color: string }>`
  width: 14px; height: 14px;
  border-radius: 50%;
  border: none;
  background: transparent;
  cursor: pointer;
  display: flex; align-items: center; justify-content: center;
  font-size: 8px;
  color: ${({ $color }) => $color};
  padding: 0;
  opacity: 0.6;
  &:hover { opacity: 1; }
`;

export const Tag: React.FC<TagProps> = ({ color, background, children, onRemove }) => (
  <StyledTag $bg={background} $color={color}>
    {children}
    {onRemove && (
      <TagRm type="button" $color={color} onClick={onRemove}>✕</TagRm>
    )}
  </StyledTag>
);
